import { SpeciesResolver } from './species.resolver'
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { ISpecies, IGallery } from 'src/app/models/Species'
import { eventToBase64PerFile } from '../../../_helpers/Media'
import { BotanicService } from '../../../services/botanic.service'
import { SpeciesService } from '../../../services/species.service'
import { AWSService } from '../../../services/aws.service'
import { NotificationService } from '../../../services/notification.service'
import { ICategoryTree } from 'src/app/models/CategoryTree'
import { ActivatedRoute } from '@angular/router'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'

@Component({
	selector: 'app-species',
	templateUrl: './species.component.html'
})
export class SpeciesComponent implements OnInit, AfterViewInit {
	constructor(
		private botanicService: BotanicService,
		private speciesService: SpeciesService,
		private awsService: AWSService,
		public notificationService: NotificationService,
		private activateRoute: ActivatedRoute
	) {}

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective
	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}

	public adultSizeSelect: Array<object> = [
		{ value: 'SMALL', label: 'Pequeno' },
		{ value: 'MEDIUM', label: 'Médio' },
		{ value: 'BIG', label: 'Grande' }
	]

	public growthRateSelect: Array<object> = [
		{ value: 'SLOW', label: 'Lento' },
		{ value: 'MODERATE', label: 'Moderado' },
		{ value: 'FAST', label: 'Rápido' }
	]

	public rootSystemSelect: Array<object> = [
		{ value: 'TABULAR', label: 'Tabular' },
		{ value: 'CONVENTIONAL', label: 'Convencional' }
	]

	public specialCategorySelect: Array<object> = [
		{ value: 'PROTECTED', label: 'Protegida' },
		{ value: 'THREATENED', label: 'Ameaçada' },
		{ value: 'INVASIVE', label: 'Invasora' },
		{ value: 'OPPORTUNIST', label: 'Oportunista' },
		{ value: 'NONE', label: 'Não se aplica' }
	]

	public woodDensitySelect: Array<object> = [
		{ value: 'LOW', label: 'Baixa' },
		{ value: 'MEDIUM', label: 'Média' },
		{ value: 'HIGH', label: 'Alta' }
	]

	public foliarPersistenceSelect: Array<object> = [
		{ value: 'PERENNIAL', label: 'Perenifólia' },
		{ value: 'SEMIDECIDUOUS', label: 'Semidecidual' },
		{ value: 'DECIDUAL', label: 'Decidual' }
	]

	public fruitSelect: Array<object> = [
		{ value: 'SMALL', label: 'Pequeno' },
		{ value: 'MEDIUM', label: 'Médio' },
		{ value: 'BIG', label: 'Grande' }
	]

	public species: ISpecies = {
		nomenclature: {
			scientificName: '',
			popularName: '',
			synonymy: '',
			botanicalClassification: ''
		},
		characterization: {
			morphologicalCharacteristics: '',
			ecologicalInformation: '',
			origin: '',
			phenology: '',
			applications: '',
			woodCharacteristics: ''
		},
		evaluationComponents: {
			adultSize: null,
			growthRate: null,
			rootSystem: null,
			specialCategory: null,
			woodDensity: null,
			foliarPersistence: null,
			fruit: null
		},
		gallery: [],
		additionalInformation: {
			bibliographicSource: '',
			recognitionTips: ''
		},
		botanicalKeys: []
	}
	public tableDataSimple: Array<ISpecies> = []
	public tableDataDetailed: Array<ISpecies> = []
	public categories: Array<ICategoryTree> = []
	public step: string = 'STEP1'
	public formIsValid: boolean = false
	public modal: {
		isOpen: boolean
		isEditing?: boolean
	} = {
		isOpen: false,
		isEditing: false
	}
	public modalDelete: {
		isOpen: boolean
		species: ISpecies
	} = {
		isOpen: false,
		species: {}
	}

	public goStep1(): void {
		this.step = 'STEP1'
		const modal: any = document.getElementsByClassName('modal active')
		modal[0].scrollTop = 0
	}

	public goStep2(): void {
		this.step = 'STEP2'
		const modal: any = document.getElementsByClassName('modal active')
		modal[0].scrollTop = 0
	}

	public reRender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public async openModal(): Promise<void> {
		try {
			this.modal.isOpen = true

			const modal: any = document.getElementsByClassName('modal active')
			setTimeout(() => {
				modal[0].scrollTop = 0
			}, 250)

			this.species = {
				nomenclature: {
					scientificName: '',
					popularName: '',
					synonymy: '',
					botanicalClassification: ''
				},
				characterization: {
					morphologicalCharacteristics: '',
					ecologicalInformation: '',
					origin: '',
					phenology: '',
					applications: '',
					woodCharacteristics: ''
				},
				evaluationComponents: {
					adultSize: null,
					growthRate: null,
					rootSystem: null,
					specialCategory: null,
					woodDensity: null,
					foliarPersistence: null,
					fruit: null
				},
				gallery: [],
				additionalInformation: {
					bibliographicSource: '',
					recognitionTips: ''
				},
				botanicalKeys: []
			}
			const categories: Array<
				ICategoryTree
			> = await this.botanicService.getClassFormated().toPromise()

			this.categories = categories
		} catch (err) {}
	}

	public openModalDelete(item: ISpecies): void {
		this.modalDelete.isOpen = true
		this.modalDelete.species = item
	}

	public closeModal(): void {
		this.modal.isEditing = false
		this.modal.isOpen = false
		this.step = 'STEP1'
	}

	public closeModalDelete(): void {
		this.modalDelete.isOpen = false
		this.modalDelete.species = {}
	}

	public ngOnInit(): void {
		// this.initTab()
		this.fetchTableResolver()
		this.setupDatatables()
		// this.fetchTableDetailed()
	}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			language: {
				url:
					'//cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json'
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				}
			]
		}
	}

	public fetchTableResolver(): void {
		this.tableDataSimple = this.activateRoute.snapshot.data.species
	}

	public async fetchTableSimple(): Promise<void> {
		const response: Array<ISpecies> = await this.speciesService
			.getSpeciesSimple()
			.toPromise()

		this.tableDataSimple = response

		this.reRender()
	}

	public getClassSize(str: string) {
		switch (str) {
			case 'SMALL':
				return 'Pequeno'
			case 'MEDIUM':
				return 'Médio'
			case 'BIG':
				return 'Grande'
		}
	}

	public getSpecialCategory(str: string) {
		switch (str) {
			case 'PROTECTED':
				return 'Protegida'
			case 'THREATENED':
				return 'Ameaçada'
			case 'INVASIVE':
				return 'Invasora'
			case 'OPPORTUNIST':
				return 'Oportunista'
			case 'NONE':
				return 'Não se aplica'
		}
	}

	// public specialCategorySelect: Array<object> = [
	// 	{ value: 'PROTECTED', label: 'Protegida' },
	// 	{ value: 'THREATENED', label: 'Ameaçada' },
	// 	{ value: 'INVASIVE', label: 'Invasora' },
	// 	{ value: 'OPPORTUNIST', label: 'Oportunista' },
	// 	{ value: 'NONE', label: 'Não se aplica' }
	// ]

	public async onSubmit(): Promise<void> {
		try {
			this.notificationService.initLoading()
			const toSend: Array<IGallery> = this.species.gallery.filter(
				item => {
					return item.type !== 'UPLOADED'
				}
			)
			const toKeep: Array<IGallery> = this.species.gallery.filter(
				item => {
					return item.type === 'UPLOADED'
				}
			)
			const gallery: any = await this.awsService.sendListPromise(toSend)
			const urls: Array<IGallery> = gallery.map(item => ({
				type: 'UPLOADED',
				string: item.Location,
				file: item
			}))
			urls.forEach(url => {
				toKeep.push(url)
			})

			const alternatives: Array<string> = []
			this.categories.forEach(cat => {
				cat.subCategories.forEach(sub => {
					if (sub.selectedAlternative !== null) {
						alternatives.push(sub.selectedAlternative)
					}
				})
			})

			this.species.gallery = toKeep.map(item => item.string)
			this.species.botanicalKeys = alternatives

			if (this.modal.isEditing) {
				await this.speciesService.patchSpecies(this.species).toPromise()
				this.notificationService.stopLoading()
				this.fetchTableSimple()

				this.modal.isEditing = false
				this.step = 'STEP1'
				this.modal.isOpen = false

				return
			}

			await this.speciesService.newSpecies(this.species).toPromise()
			this.notificationService.stopLoading()
			this.fetchTableSimple()
			this.step = 'STEP1'
			this.modal.isOpen = false
		} catch (err) {
			console.log(err)
		}
	}

	public async handleFileInput(event: any): Promise<void> {
		try {
			const files: any = event.target.files
			for (let index: number = 0; index < files.length; index++) {
				const file: any = files[index]
				const type: string = file.type.split('/')[0]
				if (type !== 'image') throw new Error('')

				const base64: any = await eventToBase64PerFile(event, index)
				this.species.gallery.push({
					type: 'base64',
					string: base64,
					file
				})
			}
			event.target.value = ''
		} catch (err) {
			this.notificationService.notify('Formato não aceito...', 420)
		}
	}

	public deletePhoto(index: number): void {
		this.species.gallery.splice(index, 1)
	}

	public clearGallery(): void {
		this.species.gallery = []
	}

	public async delete(): Promise<void> {
		try {
			const species: ISpecies = this.modalDelete.species
			await this.speciesService.deleteSpecies(species._id).toPromise()
			this.fetchTableSimple()
			this.closeModalDelete()
			// this.fetchTableDetailed()
		} catch (err) {}
	}

	public async editSpecies(item: ISpecies): Promise<void> {
		try {
			const response: any = await this.speciesService
				.getSpeciesDetails(item._id)
				.toPromise()

			const species: ISpecies = response.content

			const gallery: Array<IGallery> = species.gallery.map(x => ({
				string: x,
				type: 'UPLOADED'
			}))

			this.species = { ...species, gallery }
			this.modal.isEditing = true
			this.modal.isOpen = true

			const modal: any = document.getElementsByClassName('modal active')
			setTimeout(() => {
				modal[0].scrollTop = 0
			}, 250)

			const categories: Array<
				ICategoryTree
			> = await this.botanicService.getClassFormated().toPromise()

			const newCategories: Array<ICategoryTree> = categories.map(
				category => {
					return {
						...category,
						subCategories: category.subCategories.map(sub => {
							return {
								...sub,
								selectedAlternative: this.findSelectedAlternative(
									sub.id
								)
							}
						})
					}
				}
			)
			this.categories = newCategories
		} catch (err) {}
	}

	public findSelectedAlternative = (subId: string): string => {
		let selectedAlternative: string = null
		this.species.botanicalKeys.forEach(alternative => {
			if (alternative.subCategory === subId) {
				selectedAlternative = alternative._id
			}
		})

		return selectedAlternative
	}

	public checkForm(): boolean {
		// NOMENCLATURE
		if (this.species.nomenclature.scientificName.length === 0) {
			return false
		}
		if (this.species.nomenclature.popularName.length === 0) {
			return false
		}
		if (this.species.nomenclature.synonymy.length === 0) {
			return false
		}
		if (this.species.nomenclature.botanicalClassification.length === 0) {
			return false
		}

		// CHARACTERIZATION
		if (
			this.species.characterization.morphologicalCharacteristics
				.length === 0
		) {
			return false
		}
		if (this.species.characterization.origin.length === 0) {
			return false
		}
		if (this.species.characterization.phenology.length === 0) {
			return false
		}
		if (this.species.characterization.applications.length === 0) {
			return false
		}
		if (this.species.characterization.ecologicalInformation.length === 0) {
			return false
		}
		if (this.species.characterization.woodCharacteristics.length === 0) {
			return false
		}

		// EVALUATIONCOMPONENTS
		if (
			this.species.evaluationComponents.adultSize === null ||
			this.species.evaluationComponents.adultSize.length === 0
		) {
			return false
		}
		if (
			this.species.evaluationComponents.woodDensity === null ||
			this.species.evaluationComponents.woodDensity.length === 0
		) {
			return false
		}
		if (
			this.species.evaluationComponents.growthRate === null ||
			this.species.evaluationComponents.growthRate.length === 0
		) {
			return false
		}
		if (
			this.species.evaluationComponents.foliarPersistence === null ||
			this.species.evaluationComponents.foliarPersistence.length === 0
		) {
			return false
		}
		if (
			this.species.evaluationComponents.rootSystem === null ||
			this.species.evaluationComponents.rootSystem.length === 0
		) {
			return false
		}
		if (
			this.species.evaluationComponents.fruit === null ||
			this.species.evaluationComponents.fruit.length === 0
		) {
			return false
		}
		if (
			this.species.evaluationComponents.specialCategory === null ||
			this.species.evaluationComponents.specialCategory.length === 0
		) {
			return false
		}

		// GALLERY
		if (this.species.gallery.length === 0) {
			return false
		}

		// ADDITIONALINFORMATION
		if (
			this.species.additionalInformation.bibliographicSource.length === 0
		) {
			return false
		}
		if (this.species.additionalInformation.recognitionTips.length === 0) {
			return false
		}

		return true
	}

	// private initTab(): void {
	// 	$('[data-group]').each(function(): void {
	// 		const $allTarget: JQuery<HTMLElement> = $(this).find('[data-target]')
	// 		const $allClick: JQuery<HTMLElement> = $(this).find('[data-click]')
	// 		const activeClass: string = 'active'

	// 		$allClick.first().addClass(activeClass)
	// 		$allTarget.first().addClass(activeClass)

	// 		$allClick.click(function(e: JQuery.Event): void {
	// 			e.preventDefault()
	// 			const id: JQuery<HTMLElement> = $(this).data('click')
	// 			const $target: JQuery<HTMLElement> = $(`[data-target="${id}"]`)
	// 			$allClick.removeClass(activeClass)
	// 			$allTarget.removeClass(activeClass)
	// 			$target.addClass(activeClass)
	// 			$(this).addClass(activeClass)
	// 		})
	// 	})
	// }
}
